import { queryLayerByMII } from './layer.js';
import { toFilterString } from './utility.js';

export async function DataTransformation(role, spec, original, specifier, action, option) {
  // data query
  if (action === "add") {
    // todo: Need to consider more
    // spec.transform.filter (how to add data points?) ?? difficult!!
    // one option: adding "|| (new filter)" to every filter statement
    // another option: just provide the additional dataset
    if (option?.data !== undefined) {
      let fstr = toFilterString(option.data);
      if (spec.transform !== undefined) {
        spec.transform.forEach(transform => {
          if (transform.filter !== undefined) {
            transform.filter = transform.filter.replace(fstr, "false")
          }
        })
      }
      spec.layer.forEach(layerItem => {
        if (layerItem.transform !== undefined) {
          layerItem.transform.forEach(transform => {
            if (transform.filter !== undefined) {
              transform.filter = transform.filter.replace(fstr, "false")
            }
          })
        }
      })
    }
  } else if (action === "remove") {
    // add a filter
    // todo: a filter statement
    if (spec.transform === undefined) spec.transform = [];
    spec.transform.push({ "filter": "!" + toFilterString(specifier.data || option.data) });
    spec.layer?.forEach(layerItem => {
      if (layerItem.transform !== undefined) {
        layerItem.transform.push({ "filter": "!" + toFilterString(specifier.data || option.data) });
      }
    })
  }
  // modify; replace ... => later
  return spec;
}

export async function DataTransformTransformation(role, spec, original, specifier, action, option) {
  if (action === "add") {
    if (!specifier.layer) {
      if (spec.transform === undefined) spec.transform = [];
      if (option.operation === "filter") spec.transform.push({ "filter": option.expression });
      else if (option.operation === "compute") spec.transform.push({ "compute": option.expression, "as": option.output });
      else if (option.operation === "bin") {
        let binObj = { bin: option?.bin || true, field: option?.field };
        if (option?.nBins) binObj.maxbins = option?.nBins;
        if (option?.minstep) binObj.minstep = option?.minstep;
        if (option?.nice) binObj.nice = option?.nice;
        if (option?.step) binObj.step = option?.step;
        if (option?.steps) binObj.steps = option?.steps;
        spec.transform.push(binObj);
      }
      else if (option.operation === "aggregate") spec.transform.push({ "aggregate": option.aggregate, "field": option.field, "as": option.output });
      else if (option.operation === "calculate") {
        spec.transform.push({
          "calculate": option.expression, "as": option.output || "newCalcField"
        });
      }
      if (spec.transform.length == 0) delete spec.transform;
    } else {
      let li = queryLayerByMII(spec, specifier.layer?.mark, specifier.layer?.index, specifier.layer?.id);
      let layer = spec.layer[li];
      if (layer) {
        if (layer.transform === undefined) layer.transform = [];
        if (option.operation === "filter") layer.transform.push({ "filter": option.expression });
        else if (option.operation === "compute") layer.transform.push({ "compute": option.expression, "as": option.output });
        else if (option.operation === "bin") {
          let binObj = { bin: option?.bin || true, field: option?.field };
          if (option?.nBins) binObj.maxbins = option?.nBins;
          if (option?.minstep) binObj.minstep = option?.minstep;
          if (option?.nice) binObj.nice = option?.nice;
          if (option?.step) binObj.step = option?.step;
          if (option?.steps) binObj.steps = option?.steps;
          layer.transform.push(binObj);
        }
        else if (option.operation === "aggregate") layer.transform.push({ "aggregate": option.aggregate, "field": option.field, "as": option.output });
        else if (option.operation === "calculate") {
          layer.transform.push({
            "calculate": option.expression, "as": option.output || "newCalcField"
          });
        }
        if (layer.transform.length == 0) delete layer.transform;
      }
    }
  } else if (action === "remove" || action === "modify") {
    if (!specifier.layer) {
      spec.transform.forEach((item, i) => {
        let flag = i;
        if (specifier.operation && !Object.keys(item).includes(specifier.operation)) {
          flag = false;
        } else if (option?.operation && Object.keys(item).includes(option?.operation)) {
          flag = false;
        }
        if (specifier.field !== undefined && item.field !== specifier.field) flag = false;
        else if (action === "remove" && option?.field !== undefined && item.field !== option?.field) flag = false;

        if (specifier.expression !== undefined && item.expression !== specifier.expression) flag = false;
        else if (action === "remove" && option?.expression !== undefined && item.expression !== option?.expression) flag = false;

        if (specifier.filter !== undefined && item.filter !== specifier.filter) flag = false;
        else if (action === "remove" && option?.filter !== undefined && item.filter !== option?.filter) flag = false;

        if (specifier.output !== undefined && item.as !== specifier.output) flag = false;
        else if (action === "remove" && option?.output !== undefined && item.as !== option?.output) flag = false;

        if (specifier.index !== undefined && i !== specifier.index) flag = false;
        else if (action === "remove" && option?.index !== undefined && i !== option?.index) flag = false;

        if (flag !== false && action === "remove") {
          item.delete = true;
        } else if (flag !== false && action === "modify") {
          if (option) {
            Object.keys(option).forEach(propertyKey => {
              if (propertyKey === "operation") {
                if (item[specifier.operation]) {
                  item[option.operation] = item[specifier.operation];
                  delete item[specifier.operation];
                }
              } else if (propertyKey === "expression") {
                if (item[specifier.operation]) {
                  item[option.operation] = option.expression;
                }
              }
            })
          }
        }
      });
      spec.transform = spec.transform.filter((item, i) => { return !item.delete });
    } else {
      let li = queryLayerByMII(spec, specifier.layer?.mark, specifier.layer?.index, specifier.layer?.id);
      let layer = spec.layer[li];
      if (layer) {
        layer.transform?.forEach((item, i) => {
          let flag = i;
          if (specifier.operation && !Object.keys(item).includes(specifier.operation)) {
            flag = false;
          } else if (option?.operation && Object.keys(item).includes(option?.operation)) {
            flag = false;
          }
          if (specifier.field !== undefined && item.field !== specifier.field) flag = false;
          else if (action === "remove" && option?.field !== undefined && item.field !== option?.field) flag = false;

          if (specifier.expression !== undefined && item.expression !== specifier.expression) flag = false;
          else if (action === "remove" && option?.expression !== undefined && item.expression !== option?.expression) flag = false;

          if (specifier.filter !== undefined && item.filter !== specifier.filter) flag = false;
          else if (action === "remove" && option?.filter !== undefined && item.filter !== option?.filter) flag = false;

          if (specifier.output !== undefined && item.as !== specifier.output) flag = false;
          else if (action === "remove" && option?.output !== undefined && item.as !== option?.output) flag = false;

          if (specifier.index !== undefined && i !== specifier.index) flag = false;
          else if (action === "remove" && option?.index !== undefined && i !== option?.index) flag = false;

          if (flag !== false && action === "remove") {
            item.delete = true;
          } else if (flag !== false && action === "modify") {
            if (option) {
              Object.keys(option).forEach(propertyKey => {
                if (propertyKey === "operation") {
                  if (item[specifier.operation]) {
                    item[option.operation] = item[specifier.operation];
                    delete item[specifier.operation];
                  }
                } else if (propertyKey === "expression") {
                  if (item[specifier.operation]) {
                    item[option.operation] = option.expression;
                  }
                }
              })
            }
          }
        });
        layer.transform = layer.transform.filter((item, i) => { return !item.delete });
      }
    }
  }
  return spec;
}